/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Quicktools_Tab_MediaInputs */



/**
* | output |
* | --- |
* | "Media" |
*
* @param {Quicktools_Tab_MediaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const quicktools_tab_media = /** @type {((inputs?: Quicktools_Tab_MediaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quicktools_Tab_MediaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Médias")
	if (locale === "de") return /** @type {LocalizedString} */ ("Medien")
	if (locale === "it") return /** @type {LocalizedString} */ ("Media")
	if (locale === "ru") return /** @type {LocalizedString} */ ("СМИ")
	if (locale === "es") return /** @type {LocalizedString} */ ("Medios de comunicación")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("媒体")
	if (locale === "ja") return /** @type {LocalizedString} */ ("メディア")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मिडिया")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Mídia")
	return /** @type {LocalizedString} */ ("Media")
});